import styled from "styled-components";
import { IconButtonStyles } from "../../types/styles/IconButtonStyles";
import Icon, { IconType } from "../Icon/Icon";

const StyledButton = styled.button<{
  borderVisible?: boolean;
  disabled?: boolean;
  styles?: IconButtonStyles;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ borderVisible }) =>
    borderVisible ? "white" : "transparent"};
  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
  border: ${({ borderVisible, disabled }) =>
    borderVisible ? `1px solid ${disabled ? "#afb4b9" : "#202227"}` : "none"};
  border-radius: 50%;
  width: 32px;
  height: 32px;
  color: ${({ styles, disabled, borderVisible }) => {
    if (disabled) return "#afb4b9 !important";
    return borderVisible ? "#202227" : styles?.OverallGeneralTextColour;
  }};
  padding: 0;
  font-size: 1em;
  font-family: inherit;
  transition: border-color 0.25s;

  &:focus,
  &:focus-visible {
    outline: 4px auto -webkit-focus-ring-color;
  }
`;

export type IconButtonProps = {
  ariaLabel: string;
  onClick: () => void;
  borderVisible?: boolean;
  icon: IconType;
  disabled?: boolean;
  className?: string;
  /**
   * Optional because styles should not be passed in by
   * TimeSlotSelector. IconButton doesn't have customisable
   * styling as part of that component.
   *
   * It should be passed in by page components.
   */
  styles?: IconButtonStyles;
  dataId?: string;
};

export const IconButton: React.FC<IconButtonProps> = ({
  ariaLabel,
  onClick,
  borderVisible,
  icon,
  disabled,
  className,
  styles,
  dataId,
}) => {
  return (
    <StyledButton
      type="button"
      aria-label={ariaLabel}
      onClick={onClick}
      borderVisible={borderVisible}
      disabled={disabled}
      className={className}
      styles={styles}
      data-id={dataId}
    >
      <Icon icon={icon} />
    </StyledButton>
  );
};

export default IconButton;
